import { useCallback, useEffect, useRef, useState } from 'react';

const useWindowParamsOnScroll = (breakpoint: number): boolean => {
  const prevScrollY = useRef<number>(0);
  const [isMoreThanBreakpoint, setIsMoreThanBreakpoint] =
    useState<boolean>(false);

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;
    if (prevScrollY.current < currentScrollY && currentScrollY >= breakpoint) {
      setIsMoreThanBreakpoint(true);
    } else if (
      prevScrollY.current > currentScrollY &&
      currentScrollY < breakpoint
    ) {
      setIsMoreThanBreakpoint(false);
    }
    prevScrollY.current = currentScrollY;
  }, [prevScrollY, breakpoint]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return isMoreThanBreakpoint;
};

export default useWindowParamsOnScroll;
